<template >
  <div class="dzsflgl">
    <embed :src="url">
  </div>


</template>

<script>
import { qryVideoTypeList,updateVideoTypeInfo,delVideoTypeInfo} from '../../request/api';

export default {
  data() {
    return {
      url: window.__HEALTH_URL__.JC01,
      checkAll: false,
      tableData: [],
      search: '',
      updateForm: {
        id:'',
        typeName: '',
        createDate: ''
      },
      rules: {
        typeName: [
          { required: true, message: '分类名称不能为空', trigger: 'blur' },
          { max: 50, message: '长度小于50个字符', trigger: 'blur' }
        ]
      },
      searchForm: {
        typeName: "",
      },
      dialogFormVisible: false,
      formLabelWidth: '120px',
    };
  },
  methods: {
    loadEbookTypeList(){
      let param = {
        typeName: this.searchForm.typeName
      }
      qryVideoTypeList(param).then(
        resp => {
          if (resp.code === 1) {
            // 渲染数据
            this.tableData = resp.data;
          } else {
            this.$message.error(resp.msg);
          }
        }
      ).catch(err => {
        console.log(err)
      })
    },

    handleAdd() {
      this.dialogFormVisible = true;
      this.updateForm.id=''
      this.updateForm.typeName=''
    },
    handleEdit(row) {
      this.dialogFormVisible = true;
      this.updateForm = row
    },
    handleDelete(row) {
      this.$confirm('确定删除选中记录吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let param = {
          id: row.id
        }
        delVideoTypeInfo(param).then(
          resp => {
            if (resp.code === 1) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              // 渲染数据
              this.loadEbookTypeList();
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onSubmit() {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false
          let param = this.updateForm;
          updateVideoTypeInfo(param).then(
            resp => {
              if (resp.code === 1) {
                this.$message.success(resp.msg);
                // 重置列表
                this.loadEbookTypeList();
              } else {
                this.$message.error(resp.msg);
              }
            }
          ).catch(err => {
            console.log(err)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  mounted() {
    // 加载列表
    //this.loadEbookTypeList();
  },
  props: ["itemData"]
};
</script>

<style lang="less">
.dzsflgl{
  background-color: #EFF3FF;
  padding: 20px;
  height: calc(100vh - 216px);
}
.el-table th.el-table__cell{
    background-color: #EFF3FF;
  }

  .searchClass{
    width: 900px;
    height: 70px;
    text-align: left;
    padding-left: 20px;
  }

.searchClass .el-form-item__content {
  margin-top: 13px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
  .avatar-uploader{
    text-align: left;
  }
  .upload-demo{
    text-align: left;
  }
.dzsflgl .el-table .el-table__body-wrapper{
  height: calc(100vh - 455px);
  min-height: 250px;
  overflow-y: auto;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/sp/spsflgl.vue